/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import { ReactComponent as CommentIcon } from 'assets/icons/comments.svg'
import { ReactComponent as EmojiIcon } from 'assets/icons/emoji.svg'
import { ReactComponent as ViewIcon } from 'assets/icons/eye-show.svg'
import { ReactComponent as PinnedIcon } from 'assets/icons/pinned.svg'
import { ReactComponent as FeaturedIcon } from 'assets/icons/fire-mono.svg'

import { ReactComponent as COOLMediaLogo } from 'assets/icons/cool-media.svg'

import injectSheet from 'react-jss';
import styles from './articlecard_styles';
import Space from 'material/space/space';

const Placeholder = () => {
  return (
    <Space direction={'column'} style={{ minWidth:'80px', width: '100%'}}>
      <div className='placeholder' style={{width: '100%'}} />
      <div className='placeholder' style={{width: '80%'}} />
    </Space>
  )
}
/* ========== ~~~~~~~~~~ ARTICLE CARD ~~~~~~~~~~ ========== */
const ArticleCard = injectSheet(styles)(props => {

  const { title, imageSrc, totalComments, totalReactions, totalViews, direction, promoted, featured, showLogo, viewsLabel } = props
    return (
      <div className={`articlecard ${props.classes.articlecard} ${direction === 'horizontal' ? 'horizontal' : 'vertical'} ${promoted || featured ? 'featured' : ''}`}>
        {showLogo ? <div className={'coolmedialogo'}><COOLMediaLogo /></div> : (
          <>
            {imageSrc ? <img src={imageSrc} loading={'lazy'} alt={''} /> : <div className='imageplaceholder' />}
          </>
        )}

        <div className='articlecardinfo'> 
          <div className='statswrapper'>
            {promoted && <PinnedIcon height={24} width={24} />}
            {featured && <span className='featuredicon'><FeaturedIcon height={14} width={14}  /></span>}
            {totalComments && <div class="roundicontext">
              <CommentIcon />{totalComments}
            </div>}
          {totalReactions &&  <div class="roundicontext">
              <EmojiIcon /> {totalReactions}
            </div>}
          </div>
          <div className='titleviewwrap'>
            <div className='titlewrap'>
              {title ? 
              <span>{title}</span>
              :
              <Placeholder />
              }
            </div>
            {totalViews && <div className='viewscounter'>
                <ViewIcon /> {totalViews} {viewsLabel || 'views'}
              </div>}
          </div>
        </div>
      </div>
    )
})


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ArticleCard;
